import { FormControl, InputLabel, Select } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SelectWithLabel(props) { return /*#__PURE__*/ _jsxs(FormControl, { fullWidth: props.fullWidth, children: [/*#__PURE__*/ _jsx(InputLabel, { children: props.label }), /*#__PURE__*/ _jsx(Select, Object.assign({}, props))] }); }
